/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateNftRewardPrizeBody
 */
export interface UpdateNftRewardPrizeBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateNftRewardPrizeBody
     */
    prizeRevealName: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateNftRewardPrizeBody
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateNftRewardPrizeBody
     */
    sortOrder: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateNftRewardPrizeBody
     */
    onlyAvailableAfterWins?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftRewardPrizeBody
     */
    rewardConfigId?: string;
}

export function UpdateNftRewardPrizeBodyFromJSON(json: any): UpdateNftRewardPrizeBody {
    return UpdateNftRewardPrizeBodyFromJSONTyped(json, false);
}

export function UpdateNftRewardPrizeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNftRewardPrizeBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prizeRevealName': json['prizeRevealName'],
        'quantity': json['quantity'],
        'sortOrder': json['sortOrder'],
        'onlyAvailableAfterWins': !exists(json, 'onlyAvailableAfterWins') ? undefined : json['onlyAvailableAfterWins'],
        'rewardConfigId': !exists(json, 'rewardConfigId') ? undefined : json['rewardConfigId'],
    };
}

export function UpdateNftRewardPrizeBodyToJSON(value?: UpdateNftRewardPrizeBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prizeRevealName': value.prizeRevealName,
        'quantity': value.quantity,
        'sortOrder': value.sortOrder,
        'onlyAvailableAfterWins': value.onlyAvailableAfterWins,
        'rewardConfigId': value.rewardConfigId,
    };
}


